import axios, { AxiosPromise } from "axios";
import { Paginated } from "./common";
import type { TwinBase } from "./twinManagement";

export type UserSettings = {
  ticketAdminDateTime?: string;
  filterResponsibility?: string;
  filterWarehouse?: string;
  filterWarehouseLocation?: string;
  filterWarehouseAsset?: string[];
  // Maintenance
  maintenanceSelectedStatusesSearch?: string[] | null;
  maintenanceSelecteCreatedBySearch?: string[] | null;
  maintenanceSelectedAssigneeSearch?: string[] | null;
  maintenanceSelectedAssetSearch?: string[] | null;
  maintenanceSelectedPrioritySearch?: number | null;
  maintenanceSelectedStatusesCalendar?: string[] | null;
  maintenanceSelectedAssigneesCalendar?: string[] | null;
  maintenanceSelectedStatusesMyTickets?: string[] | null;
  // Process mining
  pmSelectedStatusesSearch?: string[] | null;
  pmSelectedCreatedBySearch?: string[] | null;
  pmSelectedAssigneeSearch?: string[] | null;
  pmSelectedAssetSearch?: string[] | null;
  pmSelectedPrioritySearch?: number | null;
  pmSelectedStatusesCalendar?: string[] | null;
  pmSelectedAssigneesCalendar?: string[] | null;
  pmSelectedStatusesMyTickets?: string[] | null;
  // Asset Management
  assetManagementSelectedStatusesSearch?: string[] | null;
  assetManagementSelectedCreatedBySearch?: string[] | null;
  assetManagementSelectedAssigneeSearch?: string[] | null;
  assetManagementSelectedAssetSearch?: string[] | null;
  assetManagementSelectedPrioritySearch?: number | null;
  assetManagementResponsibility?: string;
};

export function getUserSettings(): AxiosPromise<UserSettings> {
  return axios.get("/api/settings/user");
}

export function putUserSettings(settings: UserSettings) {
  return axios.put("/api/settings/user", settings);
}

export type MachineRestrictionPatch = {
  name: string;
  description?: string;
  propertyDefaults?: Array<{
    customId: string;
    value?: string | number | string[] | TwinBase[];
    values?: string[];
    locked?: boolean;
    hidden?: boolean;
  }>;
};

export type MachineRestrictionCreate = MachineRestrictionPatch & {
  applicationId: string;
  type: "defaultProperties";
  templateId?: string;
};

export type MachineRestrictionResponse = MachineRestrictionCreate & {
  uuid: string;
  created: string;
  modified: string;
};

export type MachineRestrictionQuery = {
  uuids?: string[];
  applicationId?: string;
  type?: string;
  page: number;
  pageSize: number;
  search?: string;
};

export function searchMachineRestrictions(
  query: MachineRestrictionQuery,
): AxiosPromise<Paginated<MachineRestrictionResponse[]>> {
  return axios.post(`/api/settings/search/hardware-restrictions`, query);
}

export function createMachineRestriction(
  request: MachineRestrictionCreate,
): AxiosPromise<MachineRestrictionResponse> {
  return axios.post(`/api/settings/hardware-restrictions`, request);
}

export function patchMachineRestriction(
  id: string,
  patch: MachineRestrictionPatch,
): AxiosPromise<MachineRestrictionResponse> {
  return axios.patch(`/api/settings/hardware-restrictions/${id}`, patch);
}

export function deleteMachineRestriction(id: string) {
  return axios.delete(`/api/settings/hardware-restrictions/${id}`);
}
